<div class="top">
  <div class="heading">
    <span class="fw-bold">GENERATE E-TICKET(S)</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">

  <form [formGroup]="form">

    <div class="form-fields">
      <div class="field">
        <label for="name" class="required">VEHICLE TYPE</label>

        @if(!vehicleTypes){
          <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
          }
          @else{

            <ng-select [items]="vehicleTypes" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
            [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
            formControlName="vehicleTypeId" class="ng-select control role-select">

          </ng-select>

          }
        <app-error-message [form]="form" controlName="vehicleTypeId" label="Vehicle Type"
          [showErrorMessage]="showErrorMessages"></app-error-message>
      </div>


      <div class="field">
        <label class="required">QUANTITY</label>


        <div class="d-flex align-items-end gap-2">
          <input type="number" min="1" formControlName="numberOfTickets" class="form-control"
            placeholder="Enter Quantity" />

          <button class="btn btn-dark d-flex align-items-center gap-1" [disabled]="isSubmitting"
            style="flex-wrap: nowrap;" (click)="addToTicketList()">
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_8839_7438" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="14"
                height="13">
                <path
                  d="M6.70118 10.8201C9.12505 10.8201 11.0899 8.85527 11.0899 6.4314C11.0899 4.00754 9.12505 2.04272 6.70118 2.04272C4.27731 2.04272 2.3125 4.00754 2.3125 6.4314C2.3125 8.85527 4.27731 10.8201 6.70118 10.8201Z"
                  fill="white" stroke="white" stroke-width="4.06307" stroke-linejoin="round" />
                <path d="M6.75616 4.24121V8.19102M4.78125 6.21612H8.73106" stroke="black" stroke-width="1.01577"
                  stroke-linecap="round" stroke-linejoin="round" />
              </mask>
              <g mask="url(#mask0_8839_7438)">
                <path d="M-13.1406 -13.4124H24.7776V24.5058H-13.1406V-13.4124Z" fill="white" />
              </g>
            </svg>
            ADD
          </button>
        </div>

        <app-error-message [form]="form" controlName="numberOfTickets" label="Quantity"
          [showErrorMessage]="showErrorMessages"></app-error-message>
      </div>
    </div>

    <table class="custom-table table-bordered">
      <thead class="custom-table-heading">
        <tr>
          <th class="ps-4">Ticket Type</th>
          <th>Quantity</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ticket of ticketList; let i = index">
          <td>{{ ticket.vehicleTypeName | titlecase }}</td>
          <td>{{ ticket.numberOfTickets | number }}</td>
          <td>
            <div class="d-flex justify-content-center">
              <button class="btn btn-danger table-action-btn" (click)="removeTicket(i)" [disabled]="isSubmitting">
                Delete
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>

  <label class="checklist-item mt-4 mb-3">
    <input type="checkbox" [(ngModel)]="rememberMe" [disabled]="isSubmitting" />
    <small style="font-size: 13px;"> I agree to this process and confirm that I have read and accepted.</small>
  </label>

  <div class="modal-actions-wrapper">
    <button type="submit" class="custom-btn-primary w-100" (click)="openConfirmModal()"
      [disabled]="ticketList.length < 1 || isSubmitting || !rememberMe">
      <ng-container *ngIf="!isSubmitting; else loadingTemplate">
        <span>Generate E-Ticket(s)</span>
      </ng-container>
      <ng-template #loadingTemplate>
        <span>Generating E-Ticket(s)...</span>
      </ng-template>
    </button>


  </div>

</div>
